import React from 'react';
import {
  RadioButtonGroup as TPARadioButtonGroup,
  type RadioButtonGroupProps,
} from 'wix-ui-tpa/cssVars';

export type { RadioButtonGroupProps };

export interface IRadioButtonGroupProps extends RadioButtonGroupProps {}

export function RadioButtonGroup(props: IRadioButtonGroupProps) {
  return <TPARadioButtonGroup {...props} />;
}

RadioButtonGroup.displayName = 'RadioButtonGroup';
